/* eslint-disable react/prefer-stateless-function */
import React from 'react';

class PartnerBanner extends React.Component {
  render() {
    const path = "https://www.efficientlearning.com";
    return (
      <div className="container banner-container">
        <div className="row">
          {this.props.partnerBlock.logo && (
          <div className="col-xs-12 col-md-5">
            <div>
              <img
                alt="partnerlogo"
                src={`${path}${this.props.partnerBlock.logo}`}
                width="249px"
                height="158px"
              />
            </div>
          </div>
          )}
          <div className="col-xs-12 col-md-7">
            <p dangerouslySetInnerHTML={{ __html: this.props && this.props.bannerData.banner_text.replace("PartnerName", this.props.partnerBlock.name) }} />
          </div>
        </div>
      </div>
    );
  }
}

export default PartnerBanner;
